import { render, staticRenderFns } from "./changeCourse.vue?vue&type=template&id=8891b25c&"
import script from "./changeCourse.vue?vue&type=script&lang=js&"
export * from "./changeCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports